import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

import logo from '../assets/logo.png';
import ic_github from '../assets/ic_github.png';
import ic_linkedin from '../assets/ic_linkedin.png';
import ic_twitter from '../assets/ic_twitter.png';
import ic_whatsapp from '../assets/ic_whatsapp.png';
import useDOMWidth from '../hooks/useDOMWidth';
import ellipsisV from '../svgs/ellipsis-v.svg';
import useScrollTop from '../hooks/useScrollTop';

const headerVariants = {
	initial: {
		backgroundPosition: '-100px 0',
	},
	animate: {
		backgroundPosition: '0px 0px',
		transition: {
			type: 'tween',
			duration: 1.5,
		},
	},
};

const overflowVariants = {
	initial: {
		height: 0,
		top: 0,
		opacity: 0.5,
	},
	animate: {
		height: 'auto',
		top: ' calc(100% + 5px)',
		opacity: 1,
		transition: {},
	},
};

const Header = ({ appTitle }) => {
	const { top } = useScrollTop(window);
	const [overflow] = useState([]);
	const [overflowVisible, setOverflowVisibility] = useState(false);
	const pages = ['Home', 'About', 'Skills', 'Services', 'Projects', 'Contact', 'FAQs'];
	const { width } = useDOMWidth(window.innerWidth);
	const fixedNav = {
		maxWidth: '100vw',
		position: 'fixed',
		top: 0,
	};
	const scrollNav = {
		maxWidth: '800px',
		position: 'absolute',
		top: 170,
	};

	useEffect(() => {
		window.scroll({ top: 0, behavior: 'smooth' });
	}, []);

	document.title = appTitle + ' | Aimikel';

	return (
		<React.Fragment>
			<motion.header variants={headerVariants} initial="initial" animate="animate" className="">
				<div className="inner flex align-center space-between  pd-md-v xl-pd-none">
					<div className="flex align-center">
						<img className="logo" src={logo} alt="aimikel logo" />
						<h1 className="sp-md-left txt-primary">
							AI<span className="txt-default">M</span>IKEL
						</h1>
					</div>
					<div className="media-links flex align-center flex-column sm-flex-row">
						<section className="flex align-center">
							<a href="https://twitter.com/aimmikel" target="_blank" rel="noreferrer" title="Twitter">
								<img className="elevate rad-sm" src={ic_twitter} alt="aimikel logo" />
							</a>
							<a href="https://www.linkedin.com/in/aimikel" target="_blank" rel="noreferrer" title="Linkedin">
								<img className="elevate rad-sm" src={ic_linkedin} alt="aimikel logo" />
							</a>
						</section>
						<section className="flex align-center sp-top sm-sp-none">
							<a href="https://www.github.com/aimmikel" target="_blank" rel="noreferrer" title="Github">
								<img className="elevate rad-sm" src={ic_github} alt="aimikel logo" />
							</a>
							<a href="https://api.whatsapp.com/send?phone=254703929108" target="_blank" rel="noreferrer" title="WhatsApp">
								<img className="elevate rad-sm" src={ic_whatsapp} alt="aimikel logo" />
							</a>
						</section>
					</div>
				</div>
				<motion.nav style={top > 170 ? fixedNav : scrollNav} exit={{ top: -100 }} className="flex align-center elevate">
					<div className="inner flex align-center space-between ">
						<div className="navs flex align-center h-60">
							{pages.map((page, index) => {
								let offset = 0;
								switch (index) {
									case 0: // home
										offset = 130;
										break;
									case 1: // about
										offset = 190;
										break;
									case 2: // skills
										offset = 250;
										break;
									case 3: // services
										offset = 330;
										break;
									case 4: // projects
										offset = 410;
										break;
									case 5: // contact
										offset = 480;
										break;
									case 6: // faqs
										offset = 490;
										break;
									default:
								}
								if (offset <= width) {
									if (overflow.indexOf(page) > -1) {
										overflow.splice(overflow.indexOf(page), 1);
									}
									return (
										<Link key={index} to={page.toLowerCase()}>
											<button className={page === appTitle ? 'active' : ''} type="button">
												{page}
											</button>
										</Link>
									);
								} else {
									if (overflow.indexOf(page) === -1) {
										overflow.push(page);
									}
									return '';
								}
							})}
						</div>
						{width < 700 && overflow.length > 0 && (
							<img
								onClick={() => setOverflowVisibility(!overflowVisible)}
								src={ellipsisV}
								alt="menu"
								className="h-40 w-40 pd bg-primary hoverable circle elevate pointer pos-absolute right-md"
							/>
						)}
						<AnimatePresence>
							{overflow.length > 0 && overflowVisible && (
								<motion.div
									exit={{
										top: 0,
										height: 0,
										opacity: 0,
									}}
									variants={overflowVariants}
									className="overflow bg-default ovf-hidden rad-sm elevate"
								>
									{pages.map((page, index) => {
										return (
											overflow.includes(page) && (
												<Link key={index} to={page.toLowerCase()}>
													<button type="button">{page}</button>
												</Link>
											)
										);
									})}
								</motion.div>
							)}
						</AnimatePresence>
					</div>
				</motion.nav>
			</motion.header>
			<div className="page-header flex align-center h-60 ln-bottom pd-md-v xl-pd-none">
				<h1 className="title font-bold">{appTitle}</h1>
			</div>
		</React.Fragment>
	);
};

export default Header;
